export class VisitType {
    VisitTypeID: number;
    VisitTypeName: string;
    VisitTypeDescription: string;
    IsActive: boolean = true;
    ModifiedBy: number;
}